import { drawerEdgeResizePlugin } from './drawerEdgeResizePlugin.js';
import { panelDrawerWidthStorage } from '@/ui/adapters/drawerWidth';

export const PANEL_MODULE_TREE_WIDTH_STORAGE_KEY = 'solvit-panel-module-tree-width';
export const PANEL_MODULE_TREE_DEFAULT_WIDTH = 378;
export const PANEL_MODULE_TREE_MIN_WIDTH = 260;
export const PANEL_MODULE_TREE_MAX_WIDTH = 560;

export function clampPanelModuleTreeWidth(width) {
  if (
    typeof width === 'number' &&
    !Number.isNaN(width) &&
    width >= PANEL_MODULE_TREE_MIN_WIDTH &&
    width <= PANEL_MODULE_TREE_MAX_WIDTH
  ) {
    return width;
  }
  return PANEL_MODULE_TREE_DEFAULT_WIDTH;
}

export async function readPanelModuleTreeWidth() {
  try {
    const saved = await panelDrawerWidthStorage.get(PANEL_MODULE_TREE_WIDTH_STORAGE_KEY);
    return clampPanelModuleTreeWidth(saved);
  } catch {
    return PANEL_MODULE_TREE_DEFAULT_WIDTH;
  }
}

/**
 * 패널 플래닝 — 오른쪽 모듈 트리 패널 width 리사이즈 (핸들: 왼쪽 가장자리)
 */
export const panelModuleTreeResizePlugin = {
  id: 'panel-module-tree-resize',

  attach(containerEl, ctx = {}) {
    return drawerEdgeResizePlugin.attach(containerEl, {
      edge: 'left',
      minWidth: PANEL_MODULE_TREE_MIN_WIDTH,
      maxWidth: PANEL_MODULE_TREE_MAX_WIDTH,
      storageKey: PANEL_MODULE_TREE_WIDTH_STORAGE_KEY,
      storage: panelDrawerWidthStorage,
      handleClass: 'drawer-edge-resize-handle panel-module-tree-resize-handle',
      ...ctx
    });
  }
};
